import { editStorageObject } from "../../../../../app/state/storageObjectSlice/actions/actions";
import { MEETING_INITIAL_VALUE } from "../../../../../features/Meeting/constants";
import {
  deleteMeetingThreadAction,
  getMeetingMessagesAction,
} from "../../../../../features/Meeting/redux/actions";
import {
  clearMessages,
  setInitRecognizeMeta,
  setMeetingValue,
} from "../../../../../features/Meeting/redux/slice";
import { MeetingsValue } from "../../../../api/instances/meetingsApi/types";
import { ServiceHandler } from "./storageHandlers";
import { generateId } from "../../../../../shared/utils/generateId";

export const MeetingsService: ServiceHandler = {
  async onCreate(listenerApi, normalized, meta) {
    if (normalized.value === null) {
      return;
    }
    try {
      await listenerApi.dispatch(
        editStorageObject({
          id: normalized.id,
          name: normalized.friendly_name,
          value: MEETING_INITIAL_VALUE,
          service: meta.arg.service,
          skipUpdateListener: true,
        }),
      );
      listenerApi.dispatch(clearMessages());
      listenerApi.dispatch(setInitRecognizeMeta(normalized?.id));
      listenerApi.dispatch(setMeetingValue(MEETING_INITIAL_VALUE));
    } catch (e) {
      console.error("Ошибка при создании объекта исследования", e);
    }
  },
  async onSelect(listenerApi, id, value) {
    if (id === null || value === null) return;
    const meetingsValue = value as MeetingsValue;
    const { thread_ref } = meetingsValue?.meetings_object;
    try {
      listenerApi.dispatch(setMeetingValue(meetingsValue));
      listenerApi.dispatch(clearMessages());
      if (thread_ref) {
        listenerApi.dispatch(getMeetingMessagesAction(thread_ref));
        return;
      }
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
  async onDelete(listenerApi, id, value) {
    if (id === null || value === null) return;
    try {
      const thread_id = (value as MeetingsValue)?.meetings_object?.thread_ref;
      if (thread_id) {
        listenerApi.dispatch(clearMessages());
        listenerApi.dispatch(deleteMeetingThreadAction(thread_id));
      }
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
};
